// Cart.js

import React, { Component } from 'react';

class Cart extends Component {
  render() {
    return (
      <div>
      Online Ice rental for 2018-2019 coming soon
      <div>
      <button className='btn btn-info' onClick={this.props.history.goBack}>Back</button>
      </div>
    </div>
    );
  }
}

export default Cart;


// WEBPACK FOOTER //
// ./src/components/Cart.js